/**
 * NATLOC API Constants
 * Extracted from natloc-component widget (v0.0.34)
 */

/**
 * API Base URLs by environment
 * Source: Widget code analysis
 */
export const NATLOC_API_URLS = {
  local: 'http://localhost:8081',
  dev: 'https://naturgy-dev-naturgy-location-api.ed-integrations.com',
  pre: 'https://naturgy-pre-naturgy-location-api.ed-integrations.com',
  pro: 'https://naturgy-location-api.ed-integrations.com',
}

/**
 * API Endpoints
 * Source: Widget code analysis
 */
export const NATLOC_ENDPOINTS = {
  AUTOCOMPLETE: '/v1/autocomplete',
  CUPS: '/v1/cups',
  DETAIL_HORIZONTAL: '/v1/detail/horizontal',
  DETAIL_HORIZONTAL_BY_PLACE_ID: '/v1/detail/horizontal/byplaceid',
  DETAIL_HORIZONTAL_BY_ID: '/v1/detail/horizontal/byid',
  DETAIL_VERTICAL: '/v1/detail/vertical',
  REGISTER_VERTICAL: '/v1/register_new_cups',
  NO_VERTICAL: '/v1/detail/vertical_not_found',
}

/**
 * Supply categories
 */
export const NATLOC_CATEGORIES = {
  ELECTRICITY: 'electricity',
  GAS: 'gas',
  GAS_AND_ELECTRICITY: 'gasAndElectricity',
  NONE: 'none',
}

/**
 * Provider types
 */
export const NATLOC_PROVIDERS = {
  NEWCO: 'newco',
  IBERIA: 'iberia',
}

/**
 * HTTP Response codes used by NATLOC API
 */
export const NATLOC_RESPONSE_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  CONFLICT: 409,
  SERVER_ERROR: 500,
}

/**
 * Response status values
 */
export const NATLOC_STATUS = {
  SUCCESS: 'success',
  NO_PLACE_ID: 'noPlaceID',
  NOT_NUMBER: 'notNumber',
  INPUT_CUPS: 'inputCups',
  ALTA: 'alta',
  NO_VERTICAL: 'noVertical',
}

/**
 * Validation regex patterns for vertical address components
 * Source: Widget validation logic
 */
export const VERTICAL_ADDRESS_FORMATS = {
  // Building: 1-99, A-Z, or BIS
  BUILDING: /(^[1-9][0-9]?$)|(\b[A-Z]{1}\b)|BIS/,
  
  // Staircase: 1-99, A-Z, INT, EXT, IZQ, DER
  STAIRCASE: /(^[1-9][0-9]?$)|(\b[A-Z]{1}\b)|INT|EXT|IZQ|DER/,
  
  // Floor: 1-99, A1-A9, S1-S9, or specific codes
  FLOOR: /(^[1-9][0-9]?$)|(\bA[1-9]\b)|(\bS[1-9]\b)|AL|AT|BJ|BU|EN|ET|PR|PT|SA|SS|ST|TR/,
  
  // Door: 1-99, A-Z, IZQ, DER
  DOOR: /(^[1-9][0-9]?$)|(^[A-Z]{1}$)|IZQ|DER/,
}

/**
 * CUPS validation constants
 */
export const CUPS_VALIDATION = {
  MIN_LENGTH: 20,
  MAX_LENGTH: 22,
  GAS_LENGTH: 20,
  REGEX: /^ES(\d{4}\d{12})([A-Z]{2})(\d[FPCRXYZ])?$/i,
  CONTROL_LETTERS: ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'],
}

/**
 * Debounce delay for autocomplete (milliseconds)
 */
export const DEBOUNCE_DELAY = 500

/**
 * Error messages (Spanish)
 * These can be overridden by i18n translations
 */
export const ERROR_MESSAGES = {
  INVALID_CUPS: 'Repasa el CUPS. Formato incorrecto.',
  CUPS_NOT_FOUND: 'No se ha encontrado la dirección asociada a tu CUPS.',
  ADDRESS_NOT_FOUND: 'No se encuentra la dirección.',
  NUMBER_NOT_FOUND: 'No se encuentra el nº de calle.',
  INVALID_NUMBER: 'El nº indicado no es correcto.',
  INVALID_POSTAL_CODE: 'El código postal indicado no es correcto.',
  INVALID_BUILDING: 'Introduzca un nº, letra o BIS.',
  INVALID_STAIRCASE: 'Introduzca un nº, letra, INT, EXT, IZQ o DER.',
  INVALID_FLOOR: 'Formato no válido.',
  INVALID_DOOR: 'Introduzca un nº, letra, IZQ o DER.',
  SERVER_ERROR: 'Este servicio no está disponible en estos momentos. Por favor, inténtalo de nuevo más tarde.',
}

/**
 * Widget version currently in use
 */
export const CURRENT_WIDGET_VERSION = '0.0.34'

/**
 * Environment variable name for NATLOC API environment
 */
export const ENV_VAR_NAME = 'REACT_APP_NATLOC_ENV'

/**
 * Fallback environment variable (legacy)
 */
export const ENV_VAR_NAME_LEGACY = 'REACT_APP_EMERGYA_ENV'